<template>
  <section id="faq">
    <v-container>
      <v-row row>
        <v-col sm="10" offset-sm="1" md="10" offset-md="1" class="px-8">
          <p class="display-2 font-weight-medium not-black text-center my-8">
            Frequently asked questions
          </p>

          <div v-for="q in faqs" :key="q.title">
            <h3 class="title font-weight-bold text-pink">
              <v-icon color="#d53f8c" class="mr-2">fas fa-caret-right</v-icon
              >{{ q.question }}
            </h3>

            <div v-html="q.answer" class="body-1 font-weight-medium"></div>
          </div>
          <p class="text-center font-weight-medium mb-6 mt-12">
            Do you have any other question? Check out the
            <a
              class="link-underlined"
              href="https://thelifeboard.app/help"
              target="_blank"
              >Help page</a
            >
            or
            <a
              class="link-underlined"
              href="https://thlifeboard.app/contact"
              target="_blank"
              >send us a message</a
            >
            🤙
          </p>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      faqs: [
        {
          question: 'What is theLIFEBOARD and how can it help me?',
          answer: `
            <p>theLIFEBOARD is a weekly planner that helps you achieve your Goals and create new Habits. It encourages you to plan your weeks defining your priorities and, complete a review ceremony at the end. Tracking your progress is one of the best ways to achieve your Goals, avoid burnout and stick to new Habits.</p>
            `,
        },
        {
          question: `Why isn't theLIFEBOARD free?`,
          answer: `
            <p>Most free apps out there sell your data to advertisers, we don't do that. That means that in order to keep things running, pay for the servers, and the time we invest in the project, we need to charge a small fee.</p>
            `,
        },
        {
          question:
            "Can I try it first? What if I don't like it after I paid? Can I cancel my subscription?",
          answer: `
              <p>You can try theLIFEBOARD for free with our free trial. If you become a paid user but you decide to stop using theLIFEBOARD later on, you can cancel your subscription at any time.</p>
              `,
        },
        {
          question: 'Why should I choose theLIFEBOARD over other apps?',
          answer: `
                <p>We think theLIFEBOARD offers a great combination of features that can help you achieve you goals. Combining goals and habits and planning and reviewing each week has proved to be a very effective method for us so we're sure it'll be super helpful for you too 😊</p><p>In addition, we'll never share your data with advertisers or any third party as stated in our <a href="https://thelifeboard.app/privacy" class="hover-underline" target="_blank">privacy policy</a>, and you'll be supporting an independent company (learn more <a class="hover-underline" href="https://thelifeboard.app/about">about us</a>) ✌️</p>
                `,
        },
        {
          question: `How do I know you'll keep supporting the project?`,
          answer: `
                <p>We use theLIFEBOARD eveyday! We've been using it for almost four years and we plan to keep using it as any other user so you can be sure we'll support the project and keep improving it 💪</p>
                `,
        },
        {
          question:
            "Can I install theLIFEBOARD in my phone? I can't find theLIFEBOARD in my app store",
          answer: `
            <p>You can install theLIFEBOARD in your smartphone as a Progressive Web App. PWA's behave as a native apps and can be installed directly from you phone web browser. Once installed theLIFEBOARD will appear in your phone home screen as any other app 😉 </p>
            `,
        },
        {
          question: 'Where can I learn more about how to use theLIFEBOARD?',
          answer: `
            <p>Visit the <a href="https://thelifeboard.app/guides" target="_blank">user guides section</a> of the website. We've included guides to help you make the most of the app and its current features and we'll keep it updated with every new feature.</p>
            `,
        },
      ],
    }
  },
}
</script>

<style></style>
